import React from "react";
import "../index.css";

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-social-links">
          <a href="https://discord.gg/productionrp" title="Discord">
            <img src="https://media.productionrp.org/website/images/discord.svg" alt="Discord" className="social-icon" />
          </a>
          <a href="https://x.com/Production__RP" title="Twitter">
            <img src="https://media.productionrp.org/website/images/twitter.svg" alt="Twitter" className="social-icon" />
          </a>
          <a href="https://www.instagram.com/production__rp" title="Instagram">
            <img src="https://media.productionrp.org/website/images/instagram.svg" alt="Instagram" className="social-icon" />
          </a>
          <a href="https://www.tiktok.com/@production__rp" title="TikTok">
            <img src="https://media.productionrp.org/website/images/tiktok.svg" alt="TikTok" className="social-icon" />
          </a>
          <a href="https://www.threads.net/@production__rp" title="Threads">
            <img src="https://media.productionrp.org/website/images/threads.svg" alt="Threads" className="social-icon" />
          </a>
          <a href="https://www.twitch.tv/productionrp" title="Twitch">
            <img src="https://media.productionrp.org/website/images/twitch.svg" alt="Twitch" className="social-icon" />
          </a>
          <a href="https://www.youtube.com/@productionrp6933" title="YouTube">
            <img src="https://media.productionrp.org/website/images/youtube.svg" alt="YouTube" className="social-icon" />
          </a>
        </div>
        <div className="footer-logo">
          <a
            href="https://www.productionrp.org/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            <img
              title="ProductionRP"
              src="https://media.productionrp.org/website/images/prplogo-30x30.webp"
              srcSet="https://media.productionrp.org/website/images/prplogo-60x60.webp 2x"
              alt="ProductionRP logo, footer"
              className="footer-image"
              loading="lazy"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
